import type { Config, UponSanitizeAttributeHook } from 'dompurify'
import DOMPurify from 'dompurify'

import domPurifyConfig from '@app/shared/config/dom-purify'

// `link_to_xhr_modal` (app/helpers/application_helper.rb) emits an inline
// onclick="modalCitizen.openXhrModal(...)" that DOMPurify would otherwise
// strip along with every other event handler. The hook keeps an onclick only
// when its whole value has the exact shape that helper emits: two JavaScript
// string literals and a JSON object whose values are booleans or quoted
// identifiers. Any code before or after the call fails the match, so the
// attribute is stripped.
const JS_STRING = String.raw`'(?:[^'\\]|\\.)*'`
const OPTION = String.raw`"\w+":(?:true|false|"[\w-]*")`
const OPTIONS = String.raw`\{(?:${OPTION}(?:,${OPTION})*)?\}`
const SAFE_XHR_MODAL_ONCLICK = new RegExp(
  String.raw`^modalCitizen\.openXhrModal\(event, ${JS_STRING}, ${JS_STRING}, ${OPTIONS}\)$`
)

export const keepXhrModalOnclick: UponSanitizeAttributeHook = (
  _node,
  event
) => {
  if (
    event.attrName === 'onclick' &&
    SAFE_XHR_MODAL_ONCLICK.test(event.attrValue)
  ) {
    event.forceKeepAttr = true
  }
}

const xhrModalConfig: Config = {
  ...domPurifyConfig,
  CUSTOM_ELEMENT_HANDLING: {
    tagNameCheck: /^sf-ce-dropdown-wrapper$/,
    attributeNameCheck:
      /^(dropdown-id|is-disabled|close-on-item-click|submenu-ids)$/,
    allowCustomizedBuiltInElements: false,
  },
}

export default function sanitizeXhrModalHtml(html: string): string {
  DOMPurify.addHook('uponSanitizeAttribute', keepXhrModalOnclick)
  try {
    return DOMPurify.sanitize(html, xhrModalConfig)
  } finally {
    DOMPurify.removeHook('uponSanitizeAttribute', keepXhrModalOnclick)
  }
}
